// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholder {
  cursor: pointer;

  background-color: rgba(33, 150, 243, 0.1);

  border: 2px solid blue;
  border-radius: 4px;
}

.placeholder::before {
  content: '{{';
  color: blue;
}

.placeholder::after {
  content: '}}';
  color: blue;
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/plugins/Placeholder/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;;EAEf,yCAAyC;;EAEzC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":[".placeholder {\n  cursor: pointer;\n\n  background-color: rgba(33, 150, 243, 0.1);\n\n  border: 2px solid blue;\n  border-radius: 4px;\n}\n\n.placeholder::before {\n  content: '{{';\n  color: blue;\n}\n\n.placeholder::after {\n  content: '}}';\n  color: blue;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
